import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const getAccountStatsBeforeCancellation = () => {
  return {
    types: [
      actionTypes.GET_ACCOUNT_STATS_BEFORE_CANCELLATION_LOADING,
      actionTypes.GET_ACCOUNT_STATS_BEFORE_CANCELLATION_SUCCESS,
      actionTypes.GET_ACCOUNT_STATS_BEFORE_CANCELLATION_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/uncompleted-projects`,
        method: `GET`,
      }),
  };
};

export const createCancellationRequest = (cancellationRequestObject, feedback, survey) => {
  const shouldUpdate =
    cancellationRequestObject &&
    cancellationRequestObject.id &&
    ["feedback", "created"].includes(cancellationRequestObject.status);
  const httpMethod = shouldUpdate ? `PUT` : `POST`;
  const url = shouldUpdate ? `/subscription/update-feedback` : `/subscription/cancel`;

  const options = {
    feedback,
    survey,
    cancellation_request_id: cancellationRequestObject?.id,
  };

  return {
    types: [
      actionTypes.CREATE_CANCELLATION_REQUEST_LOADING,
      actionTypes.CREATE_CANCELLATION_REQUEST_SUCCESS,
      actionTypes.CREATE_CANCELLATION_REQUEST_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}${url}`,
        method: httpMethod,
        body: options,
      }),
  };
};

export const verifyPassword = (password, cancellationRequestObjectId) => {
  return {
    types: [
      actionTypes.VERIFY_PASSWORD_LOADING,
      actionTypes.VERIFY_PASSWORD_SUCCESS,
      actionTypes.VERIFY_PASSWORD_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/verify-password`,
        method: `PUT`,
        body: {
          password,
          cancellation_request_id: cancellationRequestObjectId,
        },
      }),
  };
};

export const stopRetirement = () => {
  return {
    types: [
      actionTypes.STOP_RETIREMENT_LOADING,
      actionTypes.STOP_RETIREMENT_SUCCESS,
      actionTypes.STOP_RETIREMENT_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/stop-retirement`,
        method: `POST`,
      }),
  };
};
